import { Component, EventEmitter, Output, Input, ViewChild,
    ChangeDetectionStrategy
} from '@angular/core';
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendFieldGuiHint } from '../../models/frontend-field-gui-hint.model';
import { FrontendFieldType } from '../../netgen/FrontendFieldType';
import { SmFormFieldInternalComponent } from '../sm-form-field-internal/sm-form-field-internal.component';
import { FrontendForm } from '../../netgen/FrontendForm';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'sm-form-field',
    templateUrl: './sm-form-field.component.html',
    styleUrls: ['./sm-form-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SmFormFieldComponent {

    _FrontendFieldType = FrontendFieldType;
    _Utils = Utils;

    f: FrontendField;
    fixedPos = false;

    @Input()
    form: FrontendForm;
    @Input()
    field: FrontendField = null;
    @Input()
    multipleFields: FrontendField[] = null;
    @Input()
    stackLabels = true;
    @Input()
    mandatoryFieldsRedAsterisk = false;
    @Input()
    fullHeight = false;

    @Output()
    onClick = new EventEmitter<FrontendField>();

    @ViewChild("componentInternal") componentInternal: SmFormFieldInternalComponent;

    ngDoCheck(_): void {
        this.f = this.field != null ? this.field : this.multipleFields != null ? this.multipleFields[0] : null;
        this.fixedPos = this.f?.isFixedPosition();
    }

    focus(): void {
        this.componentInternal.focus();
    }

    thisComponentAsTableEditorInited(): void {
        this.componentInternal.thisComponentAsTableEditorInited();
    }

    isInlineGroup(): boolean {
        return this.multipleFields?.some(field => field.guiGroupInline) ?? false;
    }

    hasVisibleLabel(): boolean {
        if (this.multipleFields == null) {
            return this.f.hasLabelAdvanced() && !this.f.isGuiOneLine();
        }
        return this.multipleFields.some((field, index) => field.visible && field.hasLabelAdvanced() &&
            !field.isGuiOneLine() && (field.guiGroupOwnLabel || field.guiGroupOwnLabel == null && index == 0));
    }

    clickGuiHint(hint: FrontendFieldGuiHint): void {
        if (hint.onClick != null) {
            hint.onClick();
        }
    }
}
